import DB from "@/common/utils/db";

/**
 * @description 获取AI复推订单列表
 */
export function getAiCandidateList(query) {
  return DB({
    url: "v1/ais/queryCandidate",
    method: "get",
    params: query
  });
}
/**
 * @description 获取AI复推详情
 */
export function getAiCandidateDetail(query) {
  return DB({
    url: "v1/ais/listHomologous/candidate",
    method: "get",
    params: query
  });
}
/**
 * @description 获取AI做单度
 */
export function getAiMatchScore(query) {
  return DB({
    url: "v1/ais/"+query.id+"/aiMatch",
    method: "get",
    params: query
  });
}
/**
 * @description 获取AI人岗匹配列表
 */
export function getAiTalentList(query) {
  return DB({
    url: "v1/ais/getMyTalentLibrary",
    method: "get",
    params: query
  });
}
/**
 * @description 获取AI人岗匹配详情
 */
export function getAiTalentDetail(query) {
  return DB({
    url: "v1/ais/listHomologous/talent",
    method: "get",
    params: query
  });
}
/**
 * @description 获取人才标签
 */
export function getAiTalentTags(query) {
  return DB({
    url: "v1/talents/tagBaseViews",
    method: "get",
    params: query
  });
}
/**
 * @description ai复推统计未读数
 */
export function getAiRecommendCount(query) {
  return DB({
    url: "v1/ais/count/homeCandidateList/newFeedBack",
    method: "get",
    params: query
  });
}
/**
 * @description ai复推统计未读数new
 */
export function getAiRecommendCountNew(query) {
  return DB({
    url: "v1/ais/listHomologous/statistics",
    method: "get",
    params: query
  });
}
/**
 * @description ai列表小红点
 */
export function listHomologous(query) {
  return DB({
    url: "v1/ais/listHomologous/read-status",
    method: "get",
    params: query
  });
}
/**
 * @description AI复推，AI人岗匹配变更已读，未读
 */
 export function changeHomoReadStatus(query) {
  return DB({
    url: "v1/ais/changeHomoReadStatus/homoId/"+query.homoId,
    method: "get",
    params: query
  });
}

